import generateFrontUri from "@raiden/library/libraries/utils/generateFrontUrl";
import { useIntl } from "react-intl";
import Seo from "..";

function DefaultSeo() {
  const intl = useIntl();

  return (
    <Seo
      title={intl.formatMessage({
        defaultMessage: "Valentin Expertises",
      })}
      description={intl.formatMessage({
        defaultMessage:
          "Valentin Expertises, expert après sinistre, bris de machine, vol, pertes d'exploitation, incendie, tempête...",
      })}
      imageUrl={generateFrontUri({
        id: "@front.internal-assets",
        parameters: {
          filePath: "logo.svg",
        },
        includeBasePath: true,
      })}
    />
  );
}

export default DefaultSeo;
